/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Navigate_DescInputs */

const vi_qr_navigate_desc = /** @type {(inputs: Qr_Navigate_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét mã QR trên phiếu xuất kho hoặc phiếu giao hàng để xem đơn hàng`)
};

/**

* @param {Qr_Navigate_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_navigate_desc = /** @type {((inputs?: Qr_Navigate_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Navigate_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_navigate_desc(inputs)
});